export default {
  partSpecification: 'Part specification',
  treatmentInformation: 'Treatment information',
  partImages: 'Part photos',
  treatmentRemark: 'Treatment remark',
};
